/* ============================================
   TAPINNA — JS PRINCIPAL v2
   Panier : Shopify Cart API (/cart/add.js, /cart/change.js, /cart.js)
   ============================================ */
(function() {
  'use strict';

  /* ═══════════════════════════════════════════
     SHOPIFY CART API
  ═══════════════════════════════════════════ */
  const ShopifyCart = {
    async fetch() {
      const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      return res.json();
    },
    async add(variantId, qty = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Erreur ajout panier'); }
      return res.json();
    },
    async change(key, qty) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      return res.json();
    },
    async clear() {
      const res = await fetch('/cart/clear.js', { method: 'POST' });
      return res.json();
    }
  };

  /* ═══════════════════════════════════════════
     FORMAT PRIX
  ═══════════════════════════════════════════ */
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  /* ═══════════════════════════════════════════
     RENDER CART DRAWER
  ═══════════════════════════════════════════ */
  async function renderCartDrawer() {
    const body    = document.querySelector('.cart-drawer-body');
    const totalEl = document.getElementById('drawerTotal') || document.querySelector('.cart-drawer-total strong');
    const cntEls  = document.querySelectorAll('.cart-count');
    const countBadge = document.getElementById('drawerCount');
    if (!body) return;

    let data;
    try { data = await ShopifyCart.fetch(); window._lastCart = data; }
    catch(e) { body.innerHTML = '<p style="padding:2rem;text-align:center;color:var(--mid)">Erreur de chargement</p>'; return; }

    const n = data.item_count;
    cntEls.forEach(el => { el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none'; });
    if (countBadge) { countBadge.textContent = n > 0 ? `(${n})` : ''; }

    if (n === 0) {
      body.innerHTML = `<div class="cart-empty">
        <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
        <p>Votre panier est vide</p>
        <a href="/collections" class="btn-continue" style="display:inline-block;margin-top:1rem;text-decoration:underline">Découvrir nos tapis →</a>
      </div>`;
      if (totalEl) totalEl.textContent = fmt(0);
      return;
    }

    body.innerHTML = data.items.map(i => `
      <div class="line-item" data-key="${i.key}">
        <a href="${i.url}" class="line-item-img">
          <img src="${i.image.replace(/_(\d+)x(\d+)/, '_220x220')}" alt="${i.product_title}" loading="lazy" width="110" height="110">
        </a>
        <div class="line-item-info">
          <div class="line-item-top">
            <a href="${i.url}" class="line-item-name">${i.product_title}</a>
            <button class="line-remove" data-key="${i.key}" aria-label="Supprimer">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
          </div>
          ${i.variant_title && i.variant_title !== 'Default Title' ? `<div class="line-item-variant">${i.variant_title}</div>` : ''}
          <div class="line-item-bottom">
            <div class="qty-stepper">
              <button class="drawer-qty" data-key="${i.key}" data-qty="${i.quantity - 1}" aria-label="Diminuer">−</button>
              <span class="qty-val">${i.quantity}</span>
              <button class="drawer-qty" data-key="${i.key}" data-qty="${i.quantity + 1}" aria-label="Augmenter">+</button>
            </div>
            <div class="line-item-price">${fmt(i.final_line_price)}</div>
          </div>
        </div>
      </div>`).join('');

    if (totalEl) totalEl.textContent = fmt(data.total_price);

    /* Barre livraison gratuite */
    const freeAt = 5000;
    const rem = Math.max(0, freeAt - data.total_price);
    let bar = document.querySelector('.drawer-shipping-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'drawer-shipping-bar';
      body.parentNode.insertBefore(bar, body);
    }
    if (rem > 0) {
      bar.innerHTML = `<p>Plus que <strong>${fmt(rem)}</strong> pour la livraison offerte</p>
        <div class="shipping-progress"><div style="width:${Math.min(100,(data.total_price/freeAt)*100).toFixed(0)}%"></div></div>`;
    } else {
      bar.innerHTML = '<p class="shipping-done">🎉 Livraison gratuite débloquée !</p>';
    }
  }

  /* ═══════════════════════════════════════════
     AJOUTER AU PANIER
  ═══════════════════════════════════════════ */
  async function addToCart(variantId, qty, btnEl) {
    if (!variantId || variantId === 'unknown' || variantId === '') {
      showToast('S\u00e9lectionnez une variante', 'error'); return;
    }
    if (btnEl) {
      btnEl.disabled = true;
      btnEl._origText = btnEl.innerHTML;
      btnEl.innerHTML = '<span class="btn-spinner"></span>';
    }
    try {
      await ShopifyCart.add(parseInt(variantId), qty || 1);
      await renderCartDrawer();
      await renderUpsell(window._lastCart ? window._lastCart.items : []);
      openCartDrawer();
      showToast('Ajout\u00e9 au panier \u2713');
    } catch(e) {
      showToast(e.message || 'Erreur \u2014 r\u00e9essayez', 'error');
    } finally {
      if (btnEl) { btnEl.disabled = false; btnEl.innerHTML = btnEl._origText || 'Ajouter au panier'; }
    }
  }

  /* ═══════════════════════════════════════════
     TOAST
  ═══════════════════════════════════════════ */
  function showToast(msg, type) {
    let t = document.getElementById('tapinna-toast');
    if (!t) { t = document.createElement('div'); t.id = 'tapinna-toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.innerHTML = msg;
    t.className = 'toast show' + (type === 'error' ? ' toast-error' : '');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 4000);
  }

  /* ═══════════════════════════════════════════
     DRAWER / MOBILE MENU
  ═══════════════════════════════════════════ */
  function openCartDrawer() {
    document.querySelector('.cart-backdrop')?.classList.add('open');
    document.querySelector('.cart-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    document.querySelector('.cart-backdrop')?.classList.remove('open');
    document.querySelector('.cart-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  }
  function openMobMenu() { document.querySelector('.mob-menu')?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMobMenu() { document.querySelector('.mob-menu')?.classList.remove('open'); document.body.style.overflow = ''; }

  /* ═══════════════════════════════════════════
     STICKY ATC (mobile fiche produit)
  ═══════════════════════════════════════════ */
  function initStickyAtc() {
    const atcBtn = document.getElementById('addToCartBtn');
    const stickyBar = document.getElementById('stickyAtcBar');
    if (!atcBtn || !stickyBar) return;
    const obs = new IntersectionObserver(([e]) => {
      stickyBar.classList.toggle('visible', !e.isIntersecting);
      stickyBar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
      const sb = document.getElementById('stickyAtcBtn'); if(sb) sb.setAttribute('tabindex', e.isIntersecting ? '-1' : '0');
    }, { threshold: 0 });
    obs.observe(atcBtn);
  }

  /* ═══════════════════════════════════════════
     DÉLÉGATION GLOBALE
  ═══════════════════════════════════════════ */
  document.addEventListener('click', async function(e) {

    /* Qty drawer */
    const dqty = e.target.closest('.drawer-qty');
    if (dqty) { dqty.disabled = true; await ShopifyCart.change(dqty.dataset.key, Math.max(0, parseInt(dqty.dataset.qty))); await renderCartDrawer(); return; }

    /* Remove drawer */
    const rmv = e.target.closest('.line-remove');
    if (rmv) { rmv.disabled = true; await ShopifyCart.change(rmv.dataset.key, 0); await renderCartDrawer(); return; }

    /* Upsell drawer add */
    const ub = e.target.closest('[data-upsell-add]');
    if (ub) {
      e.preventDefault(); e.stopPropagation();
      const vid = ub.dataset.variantId;
      if (vid) addToCart(parseInt(vid), 1, ub);
      return;
    }

    /* Quick add sur cards */
    const qb = e.target.closest('.btn-add-quick');
    if (qb) {
      e.preventDefault(); e.stopPropagation();
      const card = qb.closest('[data-variant-id], .product-card');
      const vid = qb.dataset.variantId || card?.dataset?.variantId || card?.dataset?.id;
      await addToCart(vid, 1, qb); return;
    }

    /* ATC fiche produit */
    const atc = e.target.closest('#addToCartBtn, [data-add-to-cart]');
    if (atc && !atc.disabled && atc.id !== 'stickyAtcBtn') {
      e.preventDefault();
      const vid = atc.dataset.variantId;
      const qty = parseInt(document.getElementById('productQty')?.value) || 1;
      await addToCart(vid, qty, atc); return;
    }

    /* Sticky ATC */
    const sb = e.target.closest('#stickyAtcBtn');
    if (sb) {
      e.preventDefault();
      const vid = document.getElementById('addToCartBtn')?.dataset?.variantId;
      const qty = parseInt(document.getElementById('productQty')?.value) || 1;
      await addToCart(vid, qty, sb); return;
    }

    /* Acheter maintenant */
    const bn = e.target.closest('.btn-buy-now');
    if (bn) {
      e.preventDefault();
      const vid = document.getElementById('addToCartBtn')?.dataset?.variantId;
      if (!vid) return;
      const qty = parseInt(document.getElementById('productQty')?.value) || 1;
      bn.textContent = '...';
      try { await ShopifyCart.clear(); await ShopifyCart.add(parseInt(vid), qty); window.location.href = '/checkout'; }
      catch(err) { bn.textContent = 'Acheter maintenant'; showToast('Erreur', 'error'); }
      return;
    }

    /* Accordion */
    const ab = e.target.closest('.accordion-btn');
    if (ab) {
      const c = ab.nextElementSibling; const isOpen = c?.classList.contains('open');
      ab.closest('.accordion')?.querySelectorAll('.accordion-content.open').forEach(x => x.classList.remove('open'));
      if (!isOpen && c) c.classList.add('open'); return;
    }

    /* FAQ */
    const fb = e.target.closest('.faq-btn');
    if (fb) {
      const ans = fb.nextElementSibling; const isOpen = ans?.classList.contains('open');
      fb.classList.toggle('open', !isOpen);
      if (ans) ans.classList.toggle('open', !isOpen); return;
    }

    /* Wishlist */
    const wb = e.target.closest('.card-wish');
    if (wb) {
      e.preventDefault();
      e.stopPropagation();
      const id    = String(wb.dataset.id);
      let wlIds   = JSON.parse(localStorage.getItem('tapinna_wish') || '[]').map(String);
      let wlData  = JSON.parse(localStorage.getItem('tapinna_wish_data') || '[]');

      if (wlIds.includes(id)) {
        wlIds  = wlIds.filter(w => w !== id);
        wlData = wlData.filter(w => String(w.id) !== id);
        wb.classList.remove('active');
        showToast('Retiré des favoris');
      } else {
        wlIds.push(id);
        wlData.push({
          id,
          name:      wb.dataset.name      || '',
          url:       wb.dataset.url       || '#',
          price:     wb.dataset.price     || '',
          image:     wb.dataset.image     || '',
          variantId: wb.dataset.variantId || ''
        });
        wb.classList.add('active');
        showToast('♥ Ajouté aux favoris — <a href="/pages/favoris" style="color:#fff;text-decoration:underline">Voir mes favoris</a>');
      }
      localStorage.setItem('tapinna_wish',      JSON.stringify(wlIds));
      localStorage.setItem('tapinna_wish_data', JSON.stringify(wlData));

      const wc = document.getElementById('wishCount');
      if (wc) { wc.textContent = wlIds.length; wc.style.display = wlIds.length > 0 ? 'flex' : 'none'; }
      return;
    }

    /* Qty produit */
    const qb2 = e.target.closest('.qty-selector button');
    if (qb2) {
      const inp = document.getElementById('productQty'); if (!inp) return;
      let v = parseInt(inp.value) || 1;
      inp.value = qb2.dataset.action === 'decrease' ? Math.max(1, v - 1) : v + 1;
      return;
    }

    /* Gallery thumb */
    const gt = e.target.closest('.product-gallery__thumb');
    if (gt) {
      const idx = parseInt(gt.dataset.index) || 0;
      if (typeof tapSwitchMainImg === 'function') {
        tapSwitchMainImg(idx);
      } else {
        document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        gt.classList.add('active');
        const mi = document.getElementById('mainImg'); if (mi) mi.src = gt.dataset.src;
      }
      return;
    }

    /* Scroll btn */
    const sc = e.target.closest('.scroll-btn');
    if (sc) {
      const wrap = sc.closest('section,.section')?.querySelector('.hscroll-wrap');
      if (wrap) wrap.scrollBy({ left: (sc.dataset.dir === '1' || sc.dataset.dir === 'next') ? 300 : -300, behavior: 'smooth' }); return;
    }
  });

  /* ═══════════════════════════════════════════
     FORMULAIRES
  ═══════════════════════════════════════════ */
  document.addEventListener('submit', function(e) {
    // NE PAS bloquer : #footerNlForm et contact form soumettent vers Shopify
    // Seuls les formulaires sans action Shopify sont gérés ici
    if (e.target.id === 'heroNlForm') {
      e.preventDefault();
      const inp = e.target.querySelector('input[type="email"]');
      if (inp?.value) { showToast('Merci\u00a0! Vous \u00eates inscrit(e) \uD83C\uDF89'); inp.value = ''; }
      return;
    }
  });

  /* ═══════════════════════════════════════════
     RECHERCHE RAPIDE
  ═══════════════════════════════════════════ */
  document.querySelector('.search-wrap input')?.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && this.value.trim())
      window.location.href = '/search?q=' + encodeURIComponent(this.value.trim()) + '&type=product';
  });
  document.getElementById('mobSearchBar')?.querySelector('input')?.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && this.value.trim())
      window.location.href = '/search?q=' + encodeURIComponent(this.value.trim()) + '&type=product';
  });

  /* ═══════════════════════════════════════════
     HEADER SCROLL
  ═══════════════════════════════════════════ */
  window.addEventListener('scroll', () => {
    document.querySelector('.site-header')?.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });

  /* ═══════════════════════════════════════════
     ANIMATIONS
  ═══════════════════════════════════════════ */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.1 });

  /* ═══════════════════════════════════════════
     SUBNAV ACTIVE
  ═══════════════════════════════════════════ */
  const cp = window.location.pathname;
  document.querySelectorAll('.subnav-pill').forEach(p => { if (p.getAttribute('href') === cp) p.classList.add('active'); });

  /* ═══════════════════════════════════════════
     WISHLIST INIT
  ═══════════════════════════════════════════ */
  const wlInit = JSON.parse(localStorage.getItem('tapinna_wish') || '[]');
  wlInit.forEach(id => {
    document.querySelector(`.card-wish[data-id="${id}"]`)?.classList.add('active');
  });
  /* Badge favoris */
  const wishCountEl = document.getElementById('wishCount');
  if (wishCountEl && wlInit.length > 0) {
    wishCountEl.textContent = wlInit.length;
    wishCountEl.style.display = 'flex';
  }

  /* ═══════════════════════════════════════════
     EXPOSE + INIT
  ═══════════════════════════════════════════ */
  window.tapCart = { open: openCartDrawer, close: closeCartDrawer, add: addToCart, fetch: renderCartDrawer };
  window.tapUI   = { openMobMenu, closeMobMenu, showToast,
  toggleMobSearch: function(){ var b=document.getElementById('mobSearchBar'); if(b){ b.classList.toggle('open'); if(b.classList.contains('open')){ setTimeout(function(){ var inp=b.querySelector('input'); if(inp) inp.focus(); },300); }} }
};

  // "Lire la suite" description expand
  document.addEventListener('click', e => {
    const more = e.target.closest('.prod-desc-more');
    if (!more) return;
    e.preventDefault();
    const wrap = more.closest('.prod-desc-wrap');
    if (wrap) {
      wrap.querySelector('.prod-desc-text').textContent = more.dataset.full || '';
      more.remove();
    }
  });




  /* ═══════════════════════════════════════════
     UPSELL DRAWER — Produits complémentaires
  ═══════════════════════════════════════════ */
  async function renderUpsell(cartItems) {
    const upsellWrap = document.getElementById('drawerUpsell');
    const upsellItems = document.getElementById('drawerUpsellItems');
    if (!upsellWrap || !upsellItems) return;
    if (!cartItems || cartItems.length === 0) { upsellWrap.style.display = 'none'; return; }

    // Prendre le premier produit du panier pour les recommandations
    const firstPid = cartItems[0].product_id;
    try {
      const res = await fetch(`/recommendations/products.json?product_id=${firstPid}&limit=3&intent=related`);
      if (!res.ok) throw new Error('No recs');
      const data = await res.json();
      const prods = data.products || [];
      // Filtrer ceux déjà dans le panier
      const cartPids = cartItems.map(i => i.product_id);
      const filtered = prods.filter(p => !cartPids.includes(p.id)).slice(0, 3);
      if (filtered.length === 0) { upsellWrap.style.display = 'none'; return; }

      upsellItems.innerHTML = filtered.map(p => {
        const _rawImg = (p.featured_image && (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src)) || (p.images && p.images.length > 0 && (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src)) || '';
        const img = _rawImg ? (function(s){if(!s)return '';return s.indexOf('width=')>-1?s.replace(/width=\d+/,'width=120'):s+(s.indexOf('?')>-1?'&':'?')+'width=120';})(_rawImg) : '';
        const vid = p.variants && p.variants[0] ? p.variants[0].id : '';
        const price = p.variants && p.variants[0] ? (p.variants[0].price / 100).toFixed(2).replace('.', ',') + ' €' : '';
        return `<div class="drawer-upsell__item">
          <div class="upsell-img-wrap">${img ? `<img src="${img}" alt="${p.title}" width="60" height="60" loading="lazy">` : `<div class="upsell-img-placeholder"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="2" width="20" height="20" rx="3"/><path d="M8 12l3 3 5-5"/></svg></div>`}</div>
          <div class="drawer-upsell__item-info">
            <div class="drawer-upsell__item-name">${p.title}</div>
            <div class="drawer-upsell__item-price">${price}</div>
          </div>
          <button class="drawer-upsell__item-add" data-variant-id="${vid}" data-upsell-add>+ Ajouter</button>
        </div>`;
      }).join('');

      upsellWrap.style.display = filtered.length > 0 ? 'block' : 'none';
    } catch {
      upsellWrap.style.display = 'none';
    }
  }


  /* ═══════════════════════════════════════════
     SWIPE GALERIE MOBILE — géré par product template
  ═══════════════════════════════════════════ */
  function initGallerySwipe() {
    /* Neutralisé — le template produit gère le swipe et les dots */
  }

  function onReady(fn) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); }
    else { fn(); }
  }
  onReady(() => {
    renderCartDrawer();
    document.querySelectorAll('.anim').forEach(el => io.observe(el));
    initStickyAtc();
    initGallerySwipe();
  });

})();
